import { MatchListItem } from "components/MatchList/MatchListItem";
import { Panel } from "components/Panel/Panel";
import { TimeAttackTeamTable } from "components/ResultTable/TimeAttack/TimeAttackTeamTable";
import { Single } from "model/Tournament/Segment/Single/Single";
import { GrowColumn } from "pages/styles";
import { selectMatch } from "selectors/Match";
import { EmptyGrowPanelText, ErrorText } from "styles/text";
import { Theme } from "model/Theme";
import { MeatcTeamTable } from "components/ResultTable/TimeAttack/MeatcTeamTable";
import { getNumTeams } from "model/Match/MatchTeams";
import { JSX } from "react";
import { SmsTimeAttackTeamTable } from "components/ResultTable/TimeAttack/SmsTeamTable";
import { BdlTeamTimeAttackTable } from "components/ResultTable/TimeAttack/BdlTeamTable";
import { useAppSelector } from "app/hooks";
import { PanelList } from "components/PanelList/PanelList";

interface Props {
  tournamentId: string;
  single: Single;
  theme: Theme | undefined;
}

export const SingleTabContent = ({ tournamentId, single, theme }: Props) => {
  const match = useAppSelector((state) => selectMatch(state, single.matchId));
  const set = match?.sets.at(0);
  var panelContent: JSX.Element | undefined;
  if (!!match && !!set && set.type === "TimeAttack") {
    if (getNumTeams(match.teams) === 0) {
      panelContent = (
        <EmptyGrowPanelText>
          This tab will populate once teams are entered
        </EmptyGrowPanelText>
      );
    } else {
      if (tournamentId === "Meatcx1") {
        panelContent = (
          <MeatcTeamTable
            set={set}
            teams={match.teams}
            tournamentId={tournamentId}
          />
        );
      } else if (tournamentId === "Smsx1") {
        panelContent = (
          <SmsTimeAttackTeamTable
            set={set}
            teams={match.teams}
            tournamentId={tournamentId}
          />
        );
      } else if (tournamentId === "Bdlx1") {
        panelContent = (
          <BdlTeamTimeAttackTable
            set={set}
            teams={match.teams}
            tournamentId={tournamentId}
          />
        );
      } else {
        panelContent = (
          <TimeAttackTeamTable
            set={set}
            teams={match.teams}
            tournamentId={tournamentId}
            groups={
              tournamentId === "BwlS2"
                ? [
                    {
                      startPosition: 1,
                      endPosition: 6,
                      color: "mediumseagreen",
                    },
                    { startPosition: 7, endPosition: 22, color: "steelblue" },
                  ]
                : undefined
            }
            primaryColor={theme?.primary}
            secondaryColor={theme?.secondary}
          />
        );
      }
    }
  }

  return (
    <GrowColumn>
      <Panel>
        {!!match ? (
          <PanelList hoverColor={theme?.secondary}>
            <MatchListItem
              match={match}
              tournamentId={tournamentId}
              showTrackScores={false}
              includeDay={true}
            />
          </PanelList>
        ) : (
          <EmptyGrowPanelText>
            <ErrorText>Unable to find match</ErrorText>
          </EmptyGrowPanelText>
        )}
      </Panel>
      {!!panelContent && <Panel>{panelContent}</Panel>}
    </GrowColumn>
  );
};
